import React from "react";
import { Link } from "react-router-dom";

import aboutImg from "../../assets/images/about/ab.png";
import shapeImg from "../../assets/images/home/who-we-are.JPG";
import SectionTitle from "../../components/SectionTitle";

const HomeAboutPart = () => {
  return (
    <div className="about__area about__area_one p-relative py-5">
      <div className="container">
        <SectionTitle Title="About" subtitle="Ocfit" />
        <div className="row">
          {/* <div className="col-lg-6">
                        <div className="about__image wow animate__fadeInUp" data-wow-duration="0.3s">
                            <div className='about__side_img___container me-5'>
                                <img className='img__1' width={500} height={600} src='./img/about/about-side-img1.png' />
                                <img className='img__2' width={500} height={300} src={shapeImg} />
                            </div>
                            <img src={aboutImg} alt="About" />
                            <img className="react__shape__ab" src={shapeImg} alt="Shape Image" />   
                        </div>
                    </div> */}
          <div className="col-12">
            <div className="about__content pt-2">
              {/* <h3 className="about__title wow animate__fadeInUp" data-wow-duration="0.3s">About us<br />
                            </h3> */}
              {/* <h2 className="about__title wow animate__fadeInUp" data-wow-duration="0.3s" style={{ color: "black" }}><span style={{ color: "black" }}>Who</span> <span style={{ color: "#FE7743", fontWeight: "400" }}>we are</span> ?<br />
                            </h2> */}
              {/* <h2>Our Mission</h2> */}
              <p
                className="about__paragraph wow animate__fadeInUp text-center"
                data-wow-duration="0.5s"
              >
                Since 2008, Ocfit has been a beacon of hope for individuals from
                remote areas, lower socio-economic backgrounds, and those with
                disabilities. By focusing on empowerment, Ocfit is dedicated to
                improving social strata and living conditions through financial
                independence and job readiness.
              </p>
              <p
                className="about__paragraph wow animate__fadeInUp text-center"
                data-wow-duration="0.5s"
              >
                At Ocfit, we believe in the transformative power of education
                and vocational training. Our mission extends beyond traditional
                education; we aim to equip individuals with the power of skills
                and confidence necessary to thrive in the workforce.
              </p>
              <div className="text-center">

              <Link
                to={"/about"}
                style={{ backgroundColor: "#3D95CA",margin:"auto" }}
                className="btn btn-primary rounded-0 px-5 py-2"
              > 
                READ MORE
              </Link>

                </div>
              {/* <p className="about__paragraph2 wow animate__fadeInUp" data-wow-duration="0.7s"> Have questions?  <Link to="#"> Get Free Guide </Link></p>
                            <p className="wow animate__fadeInUp" data-wow-duration="0.9s">Education also refers to the knowledge received through schooling instruction <br/>and to the institution of teaching as a whole. The main purpose of education <br/>is the integral development of a person.</p>
                            <ul>
                                <li><Link to="/about" className="more-about wow animate__fadeInUp" data-wow-duration="1.2s"> Read More <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg></Link></li>
                                <li className="last-li wow animate__fadeInUp" data-wow-duration="1.3s">
                                    <em>Get Support</em>
                                    <a href="mailto:support@react.com">support@react.com</a>
                                </li>
                            </ul> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeAboutPart;
